import type { FlowState } from '@de/providers/dynamicExperienceReducer';

/**
 * Read the IP-inferred ISO country code from the global `flowState.location`
 * slot written by {@link initializeAutoPopulation} (already upper-cased there,
 * e.g. "US"). Returns the non-blank code, or `undefined` when the slot is
 * absent or blank.
 *
 * Centralizes the cast + non-blank guard shared by
 * {@link deriveInitialFormState} (the one-time DSM seed) and the
 * `ConfigurableStep` late-resolve bridge so the two readers stay in sync.
 */
export function readInferredCountryCode(
  flowState: FlowState | undefined,
): string | undefined {
  const location = flowState?.['location'] as
    | { countryCode?: unknown }
    | undefined;
  const code = location?.countryCode;
  return typeof code === 'string' && code.length > 0 ? code : undefined;
}
